<div class="p-grid" style="padding:20px;" >
    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">City Id</div>
        {{cityDetail?.cityId}}
    </div>
    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">City Name</div>
        {{cityDetail?.cityName}}
    </div>

    <div class="p-md-6 p-col-12">
        <div class="p-text-bold">Is Active</div>{{cityDetail?.isActive}}
    </div>
</div>
